import {
  INICIA_TURMA,
  SALVA_TURMA,
  REMOVE_TURMA,
  NOVO_TURMA,
  BUSCA_TURMA_EDICAO,
  INICIO_TURMA_SUCESSO,
  SALVA_TURMA_SUCESSO,
  REMOVE_TURMA_SUCESSO,
  BUSCA_TURMA_EDICAO_SUCESSO,
  ATUALIZA_TURMA,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_TURMA,
  LISTA_TURMA_SUCESSO,
  LIMPAR_TURMA
} from 'constants/ActionTypes';
import {
  LISTA_ESCOLAS_TURMA,
  LISTA_ESCOLAS_TURMA_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_TURMA,
  LISTA_CURSOS_POR_ESCOLA_TURMA_SUCESSO,
  LISTA_SERIES_POR_CURSO_TURMA,
  LISTA_SERIES_POR_CURSO_TURMA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA_SUCESSO,
  GET_DISCIPLINAS_TURMA,
  GET_DISCIPLINAS_TURMA_SUCCESS,
  APLICA_FILTRO_TURMA
} from 'constants/ActionTypes';

export const iniciaTurma = () => ({
  type: INICIA_TURMA
});

export const salvaTurma = (turma) => ({
  type: SALVA_TURMA,
  payload: turma
});

export const atualizaTurma = (turma) => ({
  type: ATUALIZA_TURMA,
  payload: turma
});

export const removeTurma = (id) => ({
  type: REMOVE_TURMA,
  payload: id
});

export const listaTurma = (filtros) => {
  let payload = {};
  if (typeof filtros === 'string') {
    payload = { nome: filtros };
  } else {
    payload = filtros || {};
  }

  return {
    type: LISTA_TURMA,
    payload
  };
};

export const novoTurma = () => ({
  type: NOVO_TURMA
});

export const buscaTurmaEdicao = (id) => ({
  type: BUSCA_TURMA_EDICAO,
  payload: id
});

export const inicioTurmaSucesso = (turma) => ({
  type: INICIO_TURMA_SUCESSO,
  payload: turma
});

export const salvaTurmaSucesso = (mensagem) => ({
  type: SALVA_TURMA_SUCESSO,
  payload: mensagem
});

export const onChangeFilterTurma = (e) => ({
  type: APLICA_FILTRO_TURMA,
  payload: e.target.value
});

export const removeTurmaSucesso = (mensagem) => ({
  type: REMOVE_TURMA_SUCESSO,
  payload: mensagem
});

export const buscaTurmaEdicaoSucesso = (turma) => ({
  type: BUSCA_TURMA_EDICAO_SUCESSO,
  payload: turma
});

export const listaTurmaSucesso = (turma) => ({
  type: LISTA_TURMA_SUCESSO,
  payload: { turma }
});

export const listaEscolasTurma = () => ({
  type: LISTA_ESCOLAS_TURMA
});

export const listaEscolasTurmaSucesso = (escolas) => ({
  type: LISTA_ESCOLAS_TURMA_SUCESSO,
  payload: { escolas }
});

export const limparFiltroTurma = () => ({
  type: LIMPAR_TURMA
});

export const exibirMensagemErro = (message) => ({
  type: SHOW_MESSAGE,
  payload: message
});

export const showAuthLoader = () => ({
  type: ON_SHOW_LOADER
});

export const hideMessage = () => ({
  type: HIDE_MESSAGE
});

export const showAuthMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message
});

export const showSuccessMessage = (message) => ({
  type: ON_SHOW_SUCCESS_MESSAGE,
  payload: message
});

// Combos dependentes
export const listaCursosPorEscolaTurma = (escolaId) => ({
  type: LISTA_CURSOS_POR_ESCOLA_TURMA,
  payload: { escolaId }
});

export const listaCursosPorEscolaTurmaSucesso = (cursos) => ({
  type: LISTA_CURSOS_POR_ESCOLA_TURMA_SUCESSO,
  payload: { cursos }
});

export const listaSeriesPorCursoTurma = (cursoId) => ({
  type: LISTA_SERIES_POR_CURSO_TURMA,
  payload: { cursoId }
});

export const listaSeriesPorCursoTurmaSucesso = (series) => ({
  type: LISTA_SERIES_POR_CURSO_TURMA_SUCESSO,
  payload: { series }
});

export const listaAnosLetivosPorEscolaTurma = (escolaId) => ({
  type: LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA,
  payload: { escolaId }
});

export const listaAnosLetivosPorEscolaTurmaSucesso = (anos) => ({
  type: LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA_SUCESSO,
  payload: { anos }
});

export const getDisciplinasTurma = (escolaId, serieId, ano) => ({
  type: GET_DISCIPLINAS_TURMA,
  payload: { escolaId, serieId, ano }
});

export const getDisciplinasTurmaSuccess = (disciplinas) => ({
  type: GET_DISCIPLINAS_TURMA_SUCCESS,
  payload: { disciplinas }
});
